// extracted by mini-css-extract-plugin
export default {"disclaimer":"AdminOnlyRoute_disclaimer__9RFlM","action":"AdminOnlyRoute_action__d7lDl","btn":"AdminOnlyRoute_btn__p+0hc"};